var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.927 12.927a2.728 2.728 0 11-3.854-3.855M16.4 16.4a9.155 9.155 0 01-5.4 1.872C4.636 18.272 1 11 1 11a16.772 16.772 0 014.6-5.4l10.8 10.8zM9.09 3.945A8.29 8.29 0 0111 3.727C17.364 3.727 21 11 21 11a16.818 16.818 0 01-1.964 2.9L9.091 3.945zM1 1l20 20",
    stroke: "#D3DCE6",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgEyeOff;